import { Graphics } from "@pixi/react"
import type { Graphics as PixiGraphics } from "pixi.js"
import { memo, useCallback } from "react"
import { EDGE_COLOR } from "@/domains/visualization/constants/graph"
import type { PositionedEdge } from "@/domains/visualization/types/Graph"

interface GraphEdgeProps {
  edge: PositionedEdge
}

export const GraphEdge = memo(function GraphEdge({ edge }: GraphEdgeProps) {
  const draw = useCallback(
    (g: PixiGraphics) => {
      if (!edge.sections.length) return

      g.clear()
      g.name = edge.id
      g.lineStyle({ width: 1, color: EDGE_COLOR, alpha: 1, native: true })

      for (const section of edge.sections) {
        const points = [section.startPoint, ...section.bendPoints, section.endPoint]

        g.moveTo(points[0].x, points[0].y)
        for (let i = 1; i < points.length; i++) {
          g.lineTo(points[i].x, points[i].y)
        }
      }
    },
    [edge.sections, edge.id]
  )

  return <Graphics draw={draw} />
})
